import React from 'react';
import { Link } from 'react-router-dom';

export default function Careers() {
  return (
    <>
      <section className="section section-soft careers-overview">
        <div className="container careers-layout">
          <div className="careers-highlight">
            <h2>
              Unleash your potential with limitless opportunities. Join us in shaping a dynamic,
              innovative community where your success knows no bounds. Together, let&apos;s achieve greatness.
            </h2>
            <div className="careers-links-row">
              <Link className="careers-country-link" to="/usa-careers">
                <img src="https://flagcdn.com/w40/us.png" alt="" aria-hidden="true" />
                USA Careers Page
              </Link>
              <Link className="careers-country-link" to="/india-careers">
                <img src="https://flagcdn.com/w40/in.png" alt="" aria-hidden="true" />
                India Careers Page
              </Link>
            </div>
          </div>

          <div className="careers-policy">
            <p>
              At TISSA Technology, we are committed to fostering a culture of innovation that is reflected in everything we do.
              Empower yourself with opportunities to achieve new heights and explore exciting avenues. Experience a vibrant work
              environment brimming with fresh ideas, diverse perspectives, and a shared drive for excellence.
            </p>
            <p>
              Please note that neither TISSA Technology nor any of its authorized recruitment agencies/partners charge candidates
              any registration fee or other fees for attending interviews or securing employment/internships. Candidates are advised
              to verify the credentials of any agency or consultant claiming to represent TISSA Technology in recruitment processes.
              Relying on fraudulent employment agencies is at the candidate&apos;s own risk, and TISSA Technology disclaims any liability
              for loss or damage arising as a result of such actions.
            </p>
            <p>
              TISSA Technology is proud to be an equal opportunity employer. We are dedicated to maintaining an inclusive work
              environment that respects and values diversity. We provide equal employment opportunities regardless of race, ethnicity,
              nationality, gender, gender identity, gender expression, language, age, sexual orientation, religion, marital status,
              veteran status, socio-economic status, disability, or any other characteristic protected by applicable law.
            </p>
          </div>
        </div>
      </section>
    </>
  );
}
